import React, { Component } from 'react';
import { connect } from 'react-redux';
import DeliveryMap from '../../../components/DeliveryMap/DeliveryMap';
import DeliveryOrders from '../../../components/DeliveryOrders/DeliveryOrders';
import Toolbar from '../../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../../../components/Navigation/SideDrawer/SideDrawer';
import ChangeDriverModal from '../../../components/ChangeDriverModal/ChangeDriverModal';
import * as actions from '../../../store/actions/index';
import DeliverySummary from '../../../components/DeliverySummary/DeliverySummary';
import Modal from '../../../components/UI/Modal/Modal';

class AddDelivery extends Component {
    state = {
        id: null,
        deliveryId: 0,
        driverId: 0,
        showChangeDriver: false
    }

    constructor(props) {
        super(props);
        this.state.id = this.props.id;
    }
    componentDidMount () {
        this.props.onFetchOrders();
        this.props.onGetDrivers();
        if (this.props.editDeliveryId == 0) {
            this.props.onAddDelivery();
        }
        else {
            this.props.onGetDelivery(this.props.editDeliveryId);
        }
        
    }
     
    componentDidUpdate() {
        if (this.props.id != this.state.id) {
            this.setState({id:this.props.id});
            if (this.props.editDeliveryId == 0) {
                this.props.onAddDelivery();
            }
            else {
                this.props.onGetDelivery(this.props.editDeliveryId);
            }
        }
    }

    orderUpdated = (orderId) => {
        for (let k in this.props.mapOrders) {
            if (this.props.mapOrders[k].orderId == orderId) {
                if (this.props.mapOrders[k].deliveryId == 0)
                {
                    this.props.onAddOrderToDelivery(this.props.delivery.deliveryId,orderId);
                    for (let kk in this.props.mapOrders) {
                        if (this.props.mapOrders[kk].orderId != orderId && this.props.mapOrders[kk].deliveryId == 0 && this.props.mapOrders[kk].address == this.props.mapOrders[k].address) {
                            this.props.onAddOrderToDelivery(this.props.delivery.deliveryId,this.props.mapOrders[kk].orderId);
                        }
                    }
                }
                else {
                    this.props.onRemoveOrderFromDelivery(this.props.delivery.deliveryId,orderId);
                }
                console.log("GETTING THE ORDERS");
                this.props.onFetchOrders();
                break;
            }
        }
    }

    changeDriver = () => {
        this.setState({showChangeDriver:true});        
    }

    cancelChangeDriver = () => {
        this.setState({showChangeDriver:false});
    }
   
   driverChanged = (id) => {
        this.props.onUpdateDeliveryDriver(this.props.delivery.deliveryId,id);
        this.setState({showChangeDriver:false});
   }

   addOption(visible,label,value,show) {
    if (visible)
    {
        return (
            {
                label:label,
                value:value,
                show:show
            }
        )        
    }
    else {
        return "";
    }
   }

   state = {
    showSideDrawer: false
}

sideDrawerClosedHandler = () => {
    this.setState( { showSideDrawer: false } );
}

sideDrawerToggleHandler = () => {
    this.setState( ( prevState ) => {
        return { showSideDrawer: !prevState.showSideDrawer };
    } );
}
   
    render () {
        let modal = false;
        let deliveryMap = null;
        let deliveryOrders = null;
        if (this.props.delivery) {
            deliveryMap = <DeliveryMap id={this.props.id}
            deliveryId={this.props.delivery.deliveryId}  
            key='map' 
            style={{"height":"100%"}}
            orderUpdated={this.orderUpdated}
            />;

            deliveryOrders = <DeliveryOrders 
            deliveryId={this.props.delivery.deliveryId}  
            key='orders' 
            orderUpdated={this.orderUpdated}
            />;
        }

        if (this.state.showChangeDriver) {
            modal =              
            <ChangeDriverModal driverChanged={this.driverChanged} cancelChangeDriver={this.cancelChangeDriver}/>;
        }
        
        return (
            <div style={{"height":"100%"}}>
            
                <Toolbar isAuth={this.props.isAuthenticated}
                    userType={this.props.userType}
                     drawerToggleClicked={this.sideDrawerToggleHandler} />
                <SideDrawer
                    isAuth={this.props.isAuthenticated}
                    userType={this.props.userType}
                    open={this.state.showSideDrawer}
                    closed={this.sideDrawerClosedHandler} />
                <div style={{"height":"100%"}}>
                <div style={{"height" : "60%"}}>
                {deliveryMap}
                </div>
                <div>
                    <DeliverySummary changeDriver={this.changeDriver} />
                    {deliveryOrders}
                </div>
                </div>
                <Modal show={this.state.showChangeDriver} modalClosed={this.cancelChangeDriver}>
            {modal}
          </Modal>
            </div>
        
      
                );
    }
}

const mapStateToProps = state => {
    return {
        delivery: state.orders.delivery,
        isAuthenticated: state.orders.token !== null,
        deliveryMulchTypes: state.deliveryMulchTypes,
        mapCities: state.orders.cities,
        loading: state.mapCities.loading,
        userType : state.orders.userType,
        mapOrders: state.orders.orders,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onSendDeliveryToLoad: (deliveryId) => dispatch(actions.sendDeliveryToLoad(deliveryId)),
        onAddDelivery: () => dispatch(actions.addDelivery()),
        onGetDrivers: () => dispatch(actions.getDrivers()),
        onGetDelivery: (deliveryId) => dispatch(actions.getDelivery(deliveryId)),
        onAddOrderToDelivery:(deliveryId,orderId) => dispatch(actions.addOrderToDelivery(deliveryId,orderId)),
        onRemoveOrderFromDelivery:(deliveryId,orderId) => dispatch(actions.removeOrderFromDelivery(deliveryId,orderId)),
        onFetchOrders: () => dispatch( actions.fetchOrders() ),
        onUpdateDeliveryDriver:(deliveryId,driverId) =>dispatch(actions.updateDeliveryDriver(deliveryId,driverId))
    };
};


export default connect(mapStateToProps,mapDispatchToProps)(AddDelivery);


// WEBPACK FOOTER //
// ./src/containers/Deliveries/AddDelivery/AddDelivery.js